export enum UserTypes {
  ADMIN = 'ADMIN',
  FRANCHISEE = 'FRANCHISEE',
}
export enum UserRoles {
  EDIT = 'EDIT',
  VIEW = 'VIEW',
}

export interface User {
  loginId: string;
  orgId?: string;
  firstName: string;
  lastName: string;
  email: string;
  role: UserRoles;
  type: UserTypes;
  orgUserCount: number;
  fzCode?: string;
}

export const ORG_ID_HEADER = 'x-user-org-id';
export const LOGIN_ID_HEADER = 'x-user-login-id';
export const FRANCHISEE_IMPERSONATION = 'FRANCHISEE_IMPERSONATION';
